import { gql } from '@apollo/client'

export const updateFollowersForJobRequest = gql`
    mutation UpdateJobRequestFollowers(
        $jobRequestId: Int!
        $input: UpdateJobRequestFollowersInput!
    ) {
        updateJobRequestFollowers(jobRequestId: $jobRequestId, input: $input) {
            id
            name
        }
    }
`
